// 広告なし。本番で AdSense の番号がまだ無いとき（審査の前）に使う。
// 全画面の広告は出さず、ごほうびは広告を見ずに渡す。帯の枠は空のままにして隠す（.ad-slot:empty）
import type { AdProvider } from "./types";

export const noAds: AdProvider = {
  name: "none",
  interstitial: async () => ({ shown: false }),
  rewarded: async () => ({ granted: true }),
  mountBanner(el) {
    el.replaceChildren();
  },
};
